export default __webpack_public_path__ + "static/media/search-banner-latest.c417d034.png";